import { Module } from "@/constants";
import { getDictionaryConfig } from "@/containers/dictionaries/getDictionaryConfig";
import {
  ReadDepartmentBasedProjectRates,
  WriteDepartmentBasedProjectRates,
} from "@/schemas/departmentBasedProjectRates";

export const useDepartmentBasedProjectRatesDictionary = () => {
  const config = getDictionaryConfig<
    ReadDepartmentBasedProjectRates,
    WriteDepartmentBasedProjectRates
  >(Module.DepartmentBasedProjectRates);
  return config;
};
